import FondationsServiceModel         from '@/models/FondationsServiceModel';
import UserDeletionRequestStatusModel from './UserDeletionRequestStatusModel';
import UserMeModel                    from './UserMeModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';

@model.urnResource('user_deletion_request')
@doc.path('/user_deletion_requests/{?id}')
export default class UserDeletionRequestModel extends FondationsServiceModel {

	private declare _tsFilters: {
		'user': id;
	};

	@doc.model(UserMeModel) declare user: UserMeModel;
	@doc.model(UserDeletionRequestStatusModel) declare userDeletionRequestStatus: UserDeletionRequestStatusModel;
}